import { uiText, useUiLanguage } from '../../../../../utils/uiTranslation';
import React from 'react';

const RecruiterActivityModal = ({ detail, onClose, isRTL = false, closeLabel = 'Close' }) => {
  useUiLanguage();
  if (!detail) return null;

  return (
    <div className="executive-overview-modal-backdrop" onClick={onClose}>
      <div
        className={`executive-overview-modal analytics-recruiter-modal${isRTL ? ' rtl' : ''}`}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="executive-overview-modal-head analytics-recruiter-modal-head">
          <div className="analytics-recruiter-modal-identity">
            <div className={`analytics-recruiter-card-avatar ${detail.avatarTone || 'team-blue'}`}>{detail.initials}</div>
            <div>
              <h3>{uiText(detail.label)}</h3>
              <p>{detail.headerSummary}</p>
            </div>
          </div>
          <button type="button" className="executive-overview-modal-close" onClick={onClose}>
            {closeLabel}
          </button>
        </div>

        <div className="analytics-recruiter-modal-body">
          <div className="analytics-recruiter-modal-summary">
            <div className="analytics-recruiter-modal-score">
              <span>{detail.scoreLabel}</span>
              <strong>{detail.score}</strong>
            </div>
            <div className="analytics-recruiter-modal-stat-strip">
              {(detail.summaryStats || []).map((item) => (
                <div key={item.id} className="analytics-recruiter-modal-stat">
                  <span>{uiText(item.label)}</span>
                  <strong>{item.value}</strong>
                </div>
              ))}
            </div>
          </div>

          <div className="analytics-recruiter-modal-sections">
            {(detail.sections || []).map((section) => (
              <section key={section.id} className="analytics-recruiter-modal-section">
                <h4>{uiText(section.title)}</h4>
                <div className="analytics-recruiter-modal-list">
                  {(section.items || []).length ? section.items.map((item, index) => (
                    <article key={`${section.id}-${index}`} className="analytics-recruiter-modal-item">
                      <div className="analytics-recruiter-modal-item-head">
                        <strong>{item.title}</strong>
                        {item.meta ? <span>{item.meta}</span> : null}
                      </div>
                      {item.detail ? <p>{item.detail}</p> : null}
                      {item.footer ? <small>{item.footer}</small> : null}
                    </article>
                  )) : (
                    <article className="analytics-recruiter-modal-item empty">
                      <p>{isRTL ? 'لا يوجد نشاط حديث' : 'No recent activity'}</p>
                    </article>
                  )}
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecruiterActivityModal;
